import React, { useEffect, useState } from "react";
import PublicLayout from "../components/PublicLayout";
import { api } from "../lib/api";
import { useT } from "../lib/i18n";
import { Bus } from "lucide-react";

export default function Vehicles() {
  const t = useT();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/vehicles").then(r=>setItems(r.data)).catch(()=>{}); }, []);
  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-4 pt-10 pb-16">
        <div className="text-xs uppercase tracking-widest text-[#ea580c] font-semibold">{t("veh.eyebrow")}</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tight">{t("veh.title")}</h1>
        <p className="text-slate-600 mt-4 max-w-2xl">{t("veh.subtitle")}</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {items.map(v => (
            <div key={v.id} className="p-6 rounded-2xl bg-white border border-slate-200 hover:-translate-y-1 hover:shadow-lg transition-transform" data-testid={`vehicle-card-${v.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-display font-bold text-xl text-[#1e1b4b]">{v.vehicle_type}</div>
                  <div className="text-sm text-slate-500">{v.make} {v.model}</div>
                </div>
                <Bus className="w-8 h-8 text-[#ea580c]" />
              </div>
              <div className="grid grid-cols-3 gap-2 mt-6 text-center">
                <div className="p-3 rounded-lg bg-slate-50">
                  <div className="text-2xl font-black text-[#1e1b4b]">{v.seating_capacity}</div>
                  <div className="text-[10px] uppercase tracking-widest text-slate-500 mt-1">{t("veh.seats")}</div>
                </div>
                <div className="p-3 rounded-lg bg-slate-50">
                  <div className="text-2xl font-black text-[#1e1b4b]">{v.ac ? t("hero.ac") : `${t("hero.ac")}-`}</div>
                  <div className="text-[10px] uppercase tracking-widest text-slate-500 mt-1">{t("veh.comfort")}</div>
                </div>
                <div className="p-3 rounded-lg bg-slate-50">
                  <div className="text-xs font-black text-[#1e1b4b]">{v.fuel_type}</div>
                  <div className="text-[10px] uppercase tracking-widest text-slate-500 mt-1">{t("veh.fuel")}</div>
                </div>
              </div>
              <div className="mt-4 text-xs text-slate-500">{t("veh.reg")}: {v.vehicle_number}</div>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
